'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function VCFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("mask", { id: "mantine-clwm6p5ul", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-clwm6p5ul)" }, /* @__PURE__ */ React.createElement("path", { fill: "#ffdc17", d: "M8 0h16v24H8z" }), /* @__PURE__ */ React.createElement("path", { fill: "#5fbf2b", d: "M24 0h8v24h-8z" }), /* @__PURE__ */ React.createElement("path", { fill: "#2e42a5", d: "M0 0h8v24H0z" }), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#5fbf2b",
        d: "M16.12 10.605l2.803 4.384L16.12 19.5l-3.277-4.512.397-.531.371-.497 2.305-3.082.09-.12.114-.154zM19.726 5.6l3.04 4.463-3.04 4.305-3.04-4.305 3.04-4.463zm-7.449.079l2.803 4.384-3.04 4.226L9 10.063l.397-.531.371-.497 2.304-3.082.09-.12.115-.154z"
      }
    )))
  );
}

export { VCFlag };
//# sourceMappingURL=VC.mjs.map
